/**
 * Stable CSS class names for E2E — ScheduleCreate Authentication tab.
 */
export const SCA = {
    root: 'schedule-auth-tab',
    addressInput: 'schedule-auth-tab-input__address',
    contentTypeInput: 'schedule-auth-tab-input__content-type',
    clientIdInput: 'schedule-auth-tab-input__client-id',
    clientKeyInput: 'schedule-auth-tab-input__client-key',
    usernameInput: 'schedule-auth-tab-input__username',
    authCredentialInput: 'schedule-auth-tab-input__credential',
    credentialVisibilityButton: 'schedule-auth-tab-input--button-toggle',
    credentialVisibilityIcon: 'schedule-auth-tab__toggle-icon',
    grantTypeInput: 'schedule-auth-tab-input__grant-type',
    scopeInput: 'schedule-auth-tab-input__scope',
} as const;

export const scaCls = (...parts: Array<string | undefined | false>) => parts.filter(Boolean).join(' ');
